import React from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-scroll'
import classNames from 'classnames'
import DownArrowIcon from '../Icons/DownArrow'
import UpArrowIcon from '../Icons/UpArrow'
import './pageLinkArrow.css'

const PageLinkArrow = ({to, customStyle, orientation, subtext}) => {
  const icon = orientation === 'up' ? <UpArrowIcon /> : <DownArrowIcon />
  const containerClass = classNames({'page-link-arrow-container': !customStyle})
  const btnClass = classNames('page-link-arrow-btn', {
    'page-link-arrow-btn-subtext': subtext,
  })
  return (
    <div className={containerClass}>
      <Link
        to={to}
        smooth={true}
        duration={500}
        className={btnClass}
        style={customStyle}
      >
        {icon}
        <div className="subtext">{subtext}</div>
      </Link>
    </div>
  )
}

PageLinkArrow.propTypes = {
  to: PropTypes.string.isRequired,
  customStyle: PropTypes.object,
  orientation: PropTypes.string,
  subtext: PropTypes.string,
}

export default PageLinkArrow



// WEBPACK FOOTER //
// ./src/components/PageLinkArrow/PageLinkArrow.js